import { render, staticRenderFns } from "./OverwritePositionsDialog.vue?vue&type=template&id=28a498a5&scoped=true"
import script from "./OverwritePositionsDialog.vue?vue&type=script&lang=js"
export * from "./OverwritePositionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a498a5",
  null
  
)

export default component.exports